import { useState } from 'react';
import ProjectCard from './ProjectCard';
import ProjectModal from './ProjectModal';

function ProjectCards() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const projects = [
    {
      id: 'laner',
      name: 'laner.gg',
      tagline: 'AI-Powered League of Legends Matchup Analysis',
      description: 'A live production platform that replaces tier-list guessing with real strategic understanding. Instead of just showing win rates like OP.GG or U.GG, laner.gg generates deep, coach-quality analysis for every champion and matchup — ability ranges, kit nuances, power spikes, trading patterns, and exactly how to win a lane from both sides. Built end-to-end: React frontend, FastAPI backend, Postgres on NeonDB, and a Claude-powered content pipeline generating and validating structured strategic data for all 172 champions.',
      features: [
        '172 AI-generated champion profiles: win conditions, power curves, kit nuances, combos, and counters',
        'Ability hover UI showing video, cooldown, and range on a single icon — denser than the in-game client',
        'DerivedMatchup system assembles live analysis for all ~6,500 champion pairings, so there are zero dead pages',
        'Two-tab champion page with a stat radar chart and colour-coded power curve timeline',
        'Content pipeline validates every AI output against Pydantic schemas and watermarks generated text',
        'Production hardened: Cloudflare protection, per-IP rate limiting, locked-down CORS, resume-safe seeding scripts'
      ],
      technologies: ['React', 'Vite', 'FastAPI', 'PostgreSQL (NeonDB)', 'Claude (Anthropic)', 'Pydantic', 'Netlify', 'Render', 'Cloudflare'],
      liveUrl: 'https://laner.gg',
      logo: '/images/laner-logo.png',
      previewImage: '/images/laner-preview.png',
      images: [
        { src: '/images/laner-homepage.png', caption: 'Landing page — space-themed champion & matchup search' },
        { src: '/images/laner-champion-overview.png', caption: 'Champion page (Overview) — ability hover reveals video, cooldown, and range' },
        { src: '/images/laner-champion-details.png', caption: 'Champion page (Details) — kit nuances, trading pattern, and combos' },
        { src: '/images/laner-matchup.png', caption: 'Head-to-head matchup analysis — phase guidance and win conditions' }
      ]
    },
    {
      id: 'ezstox',
      name: 'ezstox',
      tagline: 'AI-Powered Portfolio Tracker',
      description: 'A modular stock portfolio tracker with intelligent AI insights powered by OpenAI. Track your investments with real-time pricing, get AI-driven investment advice, and access comprehensive market analysis through web scraping and fundamental data integration.',
      features: [
        'Real-time portfolio tracking with accurate pricing',
        'AI advisor powered by GPT for investment insights',
        'Web scraping for news and fundamental data',
        'P/E valuations and analyst target integration'
      ],
      technologies: ['Python', 'OpenAI API', 'OpenBB', 'yFinance', 'newspaper3k'],
      githubUrl: 'https://github.com/bishalraitry/ezstox',
      logo: '/images/gojo_eye_reveal1000.png',
      previewImage: '/images/main_menu.png',
      images: [
        { src: '/images/main_menu.png', caption: 'Main Menu Interface' },
        { src: '/images/portfolio_view.png', caption: 'Portfolio Overview' },
        { src: '/images/ai_advisor.png', caption: 'AI Investment Advisor - Core Feature' }
      ]
    }
  ];

  const handleCardClick = (project) => {
    setSelectedProject(project);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedProject(null), 300);
  };

  return (
    <>
      <div className="projects-container">
        {projects.map((project) => (
          <ProjectCard
            key={project.id}
            project={project}
            onClick={handleCardClick}
          />
        ))}
      </div>

      <ProjectModal
        project={selectedProject}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </>
  );
}

export default ProjectCards;    